// Module
var code = " <input type=\"checkbox\" ng-click=\"bIndeterminateCheckbox.changeState()\" ng-model=\"bIndeterminateCheckbox.ngModel\"> ";
// Exports
module.exports = code;